import { element } from '../../../core/elements';
import { jsx as _jsx } from "react/jsx-runtime";
export const axisLineStroke = "var(--ds-border-bold, lightgrey)";
export const AxisLine = element(props => {
  const {
    style,
    hide
  } = props;
  if (hide) return null;
  return /*#__PURE__*/_jsx("div", {
    style: style
  });
});